import { createSelector, createSlice } from '@reduxjs/toolkit'
import JwtService from '../../Core/Service/LocalStorageService';
import ApiService from '../../Core/Service/ApiService';
import {jwtDecode} from 'jwt-decode';
import { floatV } from '../../Utils/utils';

let authToken = JwtService.getAuthToken();
let authUser = JwtService.getAuthUser();

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: !!authToken,
        authUser: authUser,
        authToken: authToken,
    },
    reducers: {
        setAuth: (state, action) => {
            console.log('setAuth: authUser=', action.payload.authUser);

            state.authUser = {
                ...action.payload.authUser,
                balance: floatV(action.payload.authUser.balance)
            };
            JwtService.setAuthUser(action.payload.authUser);

            if(action.payload.authToken) {
                state.authToken = action.payload.authToken;
                JwtService.setAuthToken(action.payload.authToken);
    
                state.isAuthenticated = state.authToken ? true : false;
            }
        },
        updateAuth: (state, action) => {
            console.log('updateAuth', action.payload);

            state.authUser = {
                ...state.authUser,
                ...action.payload
            }
            state.authUser = {
                ...state.authUser,
                balance: floatV(state.authUser.balance)
            }
            JwtService.setAuthUser(state.authUser);
        },
        updateAuthToken: (state, action) => {
            console.log('updateAuthToken', action.payload);

            state.authToken = action.payload;
            JwtService.setAuthToken(action.payload);
            // ApiService.setHeader(action.payload);
        },
        purgeAuth: (state) => {
            console.log('purgeAuth:');

            state.isAuthenticated = false;
            state.authUser = null;
            state.authToken = '';
            JwtService.destroyAuthToken();
            JwtService.destroyAuthUser();
            // ApiService.setHeader('');
        },
    }
})

export const { 
    setAuth, 
    updateAuth,
    updateAuthToken,
    purgeAuth, 
} = authSlice.actions

export const IsAuthenticated = (state) => state.auth.isAuthenticated;
export const getAuthUser = (state) => state.auth.authUser;
export const getAuthToken = (state) => state.auth.authToken;

// Create a memoized selector using reselect
export const memoizedGetAuthUser = createSelector(
    getAuthUser,
    (authUser) => authUser
);

export default authSlice.reducer;